import { useEffect, useRef, useState } from 'react';
import QRScan from '../../components/qr_scan';
import { useForm } from 'react-hook-form';
import CONFIG from '../../constanta/config';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import useUser from '../../hook/useUser';
import { BsFillCheckCircleFill } from 'react-icons/bs';
import moment from 'moment';
import PopupAddUser from '../../components/popup_add_user';

const PageVoting = (props) => {
  return (
    <>
      <div
        className="w-full h-screen flex flex-col justify-center items-center bg-gray-200 px-10"
        style={{
          background: `url('https://antrian.event-ku.com/images/bg.jpg') no-repeat center center fixed`,
          backgroundSize: 'cover'
        }}>
        <>
          <PopupAddUser onClose={() => {}} onSuccess={() => {}} />
        </>
      </div>
    </>
  );
};

export default PageVoting;
